<template>
  <Modal v-model="relatedComplianceInfoModal" :title="$t('key1006208')" :mask-closable="false" class-name="commonModalStyles"
    :width="800" @on-visible-change="relatedComplianceInfoChange">
    <div class="relatedComplianceInfo_box" v-for="ele in relatedComplianceInfoData">
      <div class="flex width_370 pr20">
        <div class="img_box">
          <img :src="ele.primaryImage" alt="">
        </div>
        <div class="ml12" style="flex: 1;">
          <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.name">{{ ele.name }}</h2>
          <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
          <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
          <p class="distributorThemeColor">{{ ele.specifications }}</p>
        </div>
      </div>
      <div style="flex:1">
        <!--责任人-->
        <div class="flex align-items-center mb15" v-for="item in responsibleAreaList.filter(j => j.zoneCode === zoneCode)">
          <span class="red-dot">{{ item.name + '：' }}</span>
          <Select v-model="ele.selectYmsCompliancePersonId" filterable style="width: 280px;">
            <Option v-for="k in personInChargeList.filter(talg => talg.zoneCode === zoneCode)" :value="k.ymsCompliancePersonId">
              {{ k.name }}
            </Option>
          </Select>
        </div>
        <!--制造商-->
        <div class="flex align-items-center">
          <span class="red-dot">{{ $t('key1000282') }}</span>
          <Select v-model="ele.selectYmsManufacturerInfoId" filterable style="width: 280px;">
            <Option v-for="k in manufacturerData" :value="k.ymsManufacturerInfoId">{{ k.name }}</Option>
          </Select>
        </div>
      </div>
    </div>
    <template #footer>
      <Button class="mr15" @click="relatedComplianceInfoModal = false">{{ $t('key1000112') }}</Button>
      <Button class="mr15" type="primary" @click="relatedComplianceInfoBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllManufacturerData, getAllPersonInChargeData, getCountryZoneData} from "@/utils/common";

export default {
  name: 'relatedComplianceInfoModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      relatedComplianceInfoModal: false,
      relatedComplianceInfoData: [],
      responsibleAreaList: [],
      personInChargeList: [],
      manufacturerData: [],
      ymsPlatformOrderId: null,
      zoneCode: null,
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    async initRelatedComplianceInfoData(details) {
      this.ymsPlatformOrderId = details.ymsPlatformOrderId;
      let buyerCountryCode = details.buyerCountryCode || '';
      await getAllPersonInChargeData().then((data) => {
        this.personInChargeList = data;
      });
      await getAllManufacturerData().then((data) => {
        this.manufacturerData = data;
      });
      await getCountryZoneData().then((data) => {
        this.responsibleAreaList = data;
        data.map((item) => {
          if (item.countries.includes(buyerCountryCode)) {
            this.zoneCode = item.zoneCode;
          }
        });
        let ymsProductGoodsIds = [];
        let list = [];
        let ymsPlatformOrderTransactions = details.ymsPlatformOrderTransactions || [];
        ymsPlatformOrderTransactions.map((item) => {
          item.ymsProductGoodsId = item.businessId;
          if (item.ymsProductGoodsId) {
            ymsProductGoodsIds.push(item.ymsProductGoodsId);
          }
        });
        if (ymsProductGoodsIds.length > 0) {
          this.getProductInfoByIds(ymsProductGoodsIds, ymsPlatformOrderTransactions, false, false, false).then((newList) => {
            if (newList.length > 0) {
              newList.map((item) => {
                const _productInfo = item._productInfo;
                if (_productInfo) {
                  let specificationsList = [];
                  let {_spuInfo, ymsSku, productGoodsSpecificationList} = _productInfo;
                  let {ymsProductId, name, primaryImage, ymsSpu} = _spuInfo;
                  if (productGoodsSpecificationList.length > 0) {
                    specificationsList = productGoodsSpecificationList.map((item) => {
                      return item.value;
                    });
                  }
                  let specifications = specificationsList.join(' • ');
                  list.push({
                    ...item,
                    ymsProductId,
                    name,
                    primaryImage,
                    ymsSpu,
                    ymsSku,
                    specifications,
                    selectYmsCompliancePersonId: null,
                    selectYmsManufacturerInfoId: null
                  });
                }
              });
              this.relatedComplianceInfoData = list;
            }
          });
        }
        this.relatedComplianceInfoModal = true;
      });
    },
    // 确定按钮
    relatedComplianceInfoBtn() {
      let query = {
        insertYmsCompliancePersonProductBoList: [],
        insertYmsManufacturerInfoProductBoList: [],
        ymsPlatformOrderId: this.ymsPlatformOrderId
      };
      let talg = this.relatedComplianceInfoData.every((item) => {
        return item.selectYmsCompliancePersonId && item.selectYmsManufacturerInfoId;
      });
      if (talg) {
        this.relatedComplianceInfoData.map((item) => {
          query.insertYmsCompliancePersonProductBoList.push({
            ymsCompliancePersonId: item.selectYmsCompliancePersonId,
            ymsProductId: item.ymsProductId,
            ymsDistributorMerchantId: this.userInfo.merchantId,
            zoneCode: this.zoneCode
          });
          query.insertYmsManufacturerInfoProductBoList.push({
            ymsManufacturerInfoId: item.selectYmsManufacturerInfoId,
            ymsProductId: item.ymsProductId,
            ymsDistributorMerchantId: this.userInfo.merchantId,
            zoneCode: this.zoneCode
          });
        });
        this.axios.post(api.post_ymsPlatformOrder_addComplianceImformation, query,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000280'));
            this.relatedComplianceInfoModal = false;
            this.$emit('updateData', true);
          }
        });
      } else {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006297'));
        return false;
      }
    },
    // 监听弹窗
    relatedComplianceInfoChange(value) {
      if (!value) {
        this.zoneCode = null;
        this.relatedComplianceInfoData = [];
        this.responsibleAreaList = [];
        this.personInChargeList = [];
        this.manufacturerData = [];
        this.ymsPlatformOrderId = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.commonModalStyles {
  .relatedComplianceInfo_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 16px;
    padding-bottom: 16px;

    .img_box {
      width: 80px;
      height: 80px;
      position: relative;

      img {
        display: inline-block;
        left: 50%;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }

    &:not(:last-child) {
      border-bottom: 1px solid #E2E2E2;
    }

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}
</style>
